/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// Component Imports
import CustomerPrograms from "./CustomerPrograms";
import Loading from "../../../../Components/Interactive/Loading";

// Material UI Icons
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import EditModal from "../../../../Components/EditModal";
import CancelModal from "../../../../Components/CancelModal";

// MUI Imports //
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";

// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from "@mui/icons-material/Close";

const CustomerProgramsWidget = ({
  allCustomerData,
  loading,
  setCustomerData,
  setUpdatedData,
  setTrigger,
}) => {
  const {
    userProgramsInfo,
    userDetailsInfo: { customerId },
  } = allCustomerData;

  const auth = useSelector((state) => state.auth);

  const [open, setIsOpen] = useState(true);
  const [toggleDropdown, setToggleDropdown] = useState(true);

  // Distinct modal open state (edit or cancel modals)
  const [editModalIsOpen, setEditModalisOpen] = useState(false);
  const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);

  // Modal Data State
  const [modalDataCancel, setModalDataCancel] = useState(null);
  const [modalDataEdit, setModalDataEdit] = useState(null);

  // Cancel States
  const [selectedActionId, setSelectedActionId] = useState("Cancel");
  const [comments, setComments] = useState();
  const [cancelReasonId, setCancelReasonId] = useState(133); // Cancel by default
  const [programData, setProgramInfo] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState("");
  const [billingDate, setBillingDate] = useState("");

  useEffect(() => {
    setBillingDate(userProgramsInfo.programInfo[0]?.billingDate);
    setSubscriptionStatus(userProgramsInfo.programInfo[0]?.subscriptionStatus.toUpperCase());
    setProgramInfo(userProgramsInfo);
  }, [userProgramsInfo]);

  // Cancel / Downsell program
  const handleOpenCancel = (e, program) => {
    setBillingDate(program.billingDate);
    setSubscriptionStatus(program.subscriptionStatus);
    setModalDataCancel(program);
    setCancelModalIsOpen(true);
  };

  // Edit a program - whichever is selected
  const handleOpenEdit = (e, program) => {
    setBillingDate(program.billingDate.split(" ")[0]);
    setSubscriptionStatus(program.subscriptionStatus);
    setModalDataEdit(program);
    setEditModalisOpen(true);
  };

  // Cancel a program
  const handleCancelProgram = async (e) => {
    const res = await fetch(`/api/customer/${customerId}/cancel-program`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ProgramId: modalDataCancel.programId,
        UserId: auth.userInfo.userData.userId,
        DispositionId: cancelReasonId,
        ProgramSaveId: selectedActionId === "Cancel" ? null : selectedActionId,
        Comments: comments,
      }),
    });
    const { success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: {
          ...prevState.userProgramsInfo,
          programInfo: prevState.userProgramsInfo.programInfo.map((program) => {
            if (
              program.programId === modalDataCancel.programId &&
              selectedActionId === "Cancel"
            ) {
              program["subscriptionStatus"] = "INACTIVE";
            }
            return program;
          }),
        },
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
    }
    setUpdatedData((prevState) => ({
      updateData: {
        ...prevState.updateData,
        state: success ? true : false,
        message: success
          ? selectedActionId === "Cancel"
            ? "Program canceled successfully"
            : "Program updated successfully"
          : "Failed to cancel or update users program(s)",
      },
    }));
    setTrigger("UPDATE_PROGRAM");
    setSelectedActionId("Cancel"); // reset the default to cancel (this handles case if user selects the downsell and not a cancel)
    setCancelModalIsOpen(false);
    setTrigger("");
  };

  // Update a program
  const handleUpdateProgram = async (e) => {
    let subStatus = 0;
    switch (subscriptionStatus) {
      case "ACTIVE":
        subStatus = 1;
        break;
      case "PAUSED":
        subStatus = 3;
        break;
      default:
        subStatus = 0;
    }

    const res = await fetch(`/api/customer/${customerId}/update-program`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        UserId: auth.userInfo.userData.userId,
        SubscriptionId: modalDataEdit.subscriptionId,
        BillingDate: `${billingDate} 00:00:00`,
        Interval: modalDataEdit.interval,
        Cycles: modalDataEdit.cycles,
        Status: subStatus,
      }),
    });
    const { success } = await res.json();
    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: {
          ...prevState.userProgramsInfo,
          programInfo: prevState.userProgramsInfo.programInfo.map((program) => {
            if (program.programId === modalDataEdit.programId) {
              program["subscriptionStatus"] = subscriptionStatus;
              program["billingDate"] = `${billingDate} 00:00:00`;
            }
            return program;
          }),
        },
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
    }
    setUpdatedData((prevState) => ({
      ...prevState.updateData,
      updateData: {
        ...prevState.updateDataSuccess,
        state: success ? true : false,
        message: success
          ? "Program updated successfully"
          : "Failed to update users program information",
      },
    }));
    setTrigger("UPDATE_PROGRAM");
    setSubscriptionStatus(subscriptionStatus);
    setEditModalisOpen(false);
    setTrigger("");
  };

  const renderProcessBtn = () => {
    const billingDate = new Date(modalDataEdit.billingDate);
    const currentDate = new Date();
    const isActive = modalDataEdit.subscriptionStatus.toLowerCase();
    return isActive === 'active' && billingDate < currentDate;
  }

  const renderResetSubscriptionPricingBtn = () => {
    if(modalDataEdit.originalProductId === undefined || modalDataEdit.productId !== modalDataEdit.originalProductId) {
      return true;
    }else{
      return false;
    }
  }

  const processSubscription = async () => {
    const subId = modalDataEdit.subscriptionId;
    const res = await fetch(`/api/customer/${customerId}/process-program`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        SubscriptionId: subId
      }),
    });
    const { success, message } = await res.json();
    if(success) {
      setEditModalisOpen(false);
      setTrigger("UPDATE_PROGRAM");
      setUpdatedData((prevState) => ({
        ...prevState.updateData,
        updateData: {
          ...prevState.updateDataSuccess,
          state: true,
          message: "Subscription Processed Successfully"
        },
      }));
    }else {
      console.error('ERROR! check logs');
      setEditModalisOpen(false);
      setTrigger("UPDATE_PROGRAM");
      setUpdatedData((prevState) => ({
        ...prevState.updateData,
        updateData: {
          ...prevState.updateDataSuccess,
          state: false,
          message: message
        },
      }));
    }
  }

  const resetSubscriptionPricing = async () => {
    const subId = modalDataEdit.subscriptionId;
    const res = await fetch(`/api/customer/${customerId}/reset-subscription-pricing`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        UserId: auth.userInfo.userData.userId,
        SubscriptionId: subId,
      }),
    });
    const { success, message } = await res.json();
    if(success) {
      setEditModalisOpen(false);
      setTrigger("UPDATE_PROGRAM");
      setUpdatedData((prevState) => ({
        ...prevState.updateData,
        updateData: {
          ...prevState.updateDataSuccess,
          state: true,
          message: "Subscription Processed Successfully"
        },
      }));
    }else {
      console.error('ERROR! check logs');
      setEditModalisOpen(false);
      setTrigger("UPDATE_PROGRAM");
      setUpdatedData((prevState) => ({
        ...prevState.updateData,
        updateData: {
          ...prevState.updateDataSuccess,
          state: false,
          message: message
        },
      }));
    }
  }

  const isDefined = () =>
    programData &&
    programData.programInfo &&
    programData.programInfo.length > 0;
  return (
    <div
      className={`user-data-container ${
        isDefined() ? "" : "user-data-container-squeezed"
      } 
    ${open ? "show-program-widget" : "hide-program-widget"}`}
    style={{marginBottom: "1rem"}}
    >
      <div className="customer-widget-header">
        <p className="customer-widget-heading" style={{ width: "6rem" }}>
          Programs
        </p>
        {programData &&
          programData.programInfo &&
          programData.programInfo.length > 0 && (
            <ArrowDropDownIcon
              onClick={() => {
                setIsOpen(!open);
                setToggleDropdown(!toggleDropdown);
              }}
              className={`arrow-dropdown ${
                toggleDropdown ? "arrow-open" : "arrow-close"
              }`}
            />
          )}
      </div>
      <div className={`data-push ${open ? "show-data" : "no-data"}`}>
        {loading ? (
          <div className="loading-widget">
            <Loading />
          </div>
        ) : (
          <>
            <CancelModal
              open={cancelModalIsOpen}
              handleClose={() => setCancelModalIsOpen(false)}
            >
              <div className="modal-header">
                <h2 style={{ padding: ".5rem", color: "#6acde6"}}>
                  {modalDataCancel?.programName}
                </h2>
                <CloseIcon
                  className="close-icons"
                  onClick={() => setCancelModalIsOpen(false)}
                />
              </div>
              <br />
              <div className="top-select">
                <FormControl
                  variant="outlined"
                  style={{ margin: 8, width: "18rem" }}
                  onChange={(e) => setSelectedActionId(e.target.value)} // Save the programSaveId (the action on this program)
                >
                  <InputLabel htmlFor="outlined-age-native-simple">
                    {"Action"}
                  </InputLabel>
                  <Select native={true} label={"Cancel"}>
                    <option value={null}>{"Cancel"}</option>
                    {modalDataCancel?.downsellData.map((action, idx) => {
                      return (
                        <option key={idx} value={action.programSaveId}>
                          {action.saveName}
                        </option>
                      );
                    })}
                  </Select>
                </FormControl>
                {selectedActionId === "Cancel" && (
                  <FormControl
                    variant="outlined"
                    style={{ margin: 8, width: "18rem" }}
                    onChange={(e) => setCancelReasonId(e.target.value)} // CancelReason only shows when a user wants to cancel, so, this will only send data if cancel is selected
                  >
                    <InputLabel htmlFor="outlined-age-native-simple">
                      {"Reason"}
                    </InputLabel>
                    <Select native label={"Reason"}>
                      {[
                        {
                          disposition_desc: "Called Cancel",
                          disposition_id: 133,
                        },
                        { disposition_desc: "VM Cancel", disposition_id: 134 },
                        { disposition_desc: "Em Cancel", disposition_id: 135 },
                      ].map(({ disposition_desc, disposition_id }, idx) => {
                        return (
                          <option key={idx} value={disposition_id}>
                            {disposition_desc}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                )}
              </div>
              <br />
              <TextField
                id="outlined-multiline-static"
                label="Comments..."
                multiline
                rows={4}
                variant="outlined"
                fullWidth={true}
                onChange={(e) => setComments(e.target.value)}
              />
              <br />
              <div className="program-modal-btns">
                <button
                  className="update-program-cta"
                  onClick={(e) => handleCancelProgram(e)}
                >
                  <span>Submit</span>
                </button>
              </div>
            </CancelModal>
            <EditModal
              open={editModalIsOpen}
              handleClose={() => setEditModalisOpen(false)}
            >
              <div className="modal-header">
                <h2 style={{ padding: ".5rem", color: "#6acde6" }}>
                  Update {modalDataEdit?.programName}
                </h2>
                <CloseIcon
                  className="close-icons"
                  onClick={() => setEditModalisOpen(false)}
                />
              </div>
              <br />
              <FormControl
                variant="outlined"
                style={{ margin: 8, width: "18rem" }}
                onChange={(e) => setSubscriptionStatus(e.target.value)} // CancelReason only shows when a user wants to cancel, so, this will only send data if cancel is selected
              >
                <InputLabel htmlFor="outlined-age-native-simple">
                  {"Subscription Status"} 
                </InputLabel>
                <Select native label={"Reason"} value={subscriptionStatus}>
                  <option value={subscriptionStatus}>{subscriptionStatus}</option>
                  <option value={"ACTIVE"}>{"Active"}</option>
                  <option value={"INACTIVE"}>{"Inactive"}</option>
                  <option value={"PAUSED"}>{"Paused"}</option>
                </Select>
              </FormControl>
              <br />
              <TextField
                id="outlined-full-width"
                className="input-el"
                label={"Billing Date"}
                type="date"
                style={{ margin: 8, width: "14rem" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={billingDate}
                onChange={(e) => setBillingDate(e.target.value)}
              />
              <br />
              <div className="program-modal-btns">
                <button
                  className="update-program-cta"
                  onClick={(e) => handleUpdateProgram(e)}
                >
                  <span>Update Program</span>
                </button>
              </div>
              <br />
              {editModalIsOpen && renderProcessBtn() && <div className="program-modal-btns">
                <button
                  className="process-program-btn"
                  onClick={(e) => processSubscription()}
                >
                  <span>Process Subscription Now</span>
                </button>
              </div>}
              <br />
              {editModalIsOpen && renderResetSubscriptionPricingBtn() &&  <div className="program-modal-btns">
                <button
                  className="reset-program-btn"
                  onClick={(e) => resetSubscriptionPricing()}
                >
                  <span>Reset pricing</span>
                </button>
              </div>}
            </EditModal>
            {isDefined() ? (
              <CustomerPrograms
                programData={programData}
                handleOpenEdit={handleOpenEdit}
                handleOpenCancel={handleOpenCancel}
                isDefined={isDefined}
                open={open}
              />
            ) : (
              <h3 style={{ fontSize: "1rem" }}>No Programs</h3>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CustomerProgramsWidget;
